import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

@Injectable()
export class AdminAuthGuardService implements CanActivate {

    constructor(private router: Router) { }

    canActivate()
    { 
        if (sessionStorage.getItem('AdminUser'))
        {
            // logged in so return true
            return true;
        }
      
        // not logged in so redirect to login page      
      this.router.navigate(['/Unauthorized/access']);
        return false;
    }
}
